import apiClient from './ApiClient';

export class SubscriptionRepository {
	constructor(client) {
		this.client = client;
		this.basePath = '/api/subscriptions';
	}

	/**
	 * Get current subscription for the logged-in company
	 * @returns {Promise<Object>} Subscription details including plan, status, usage
	 */
	async getCurrent() {
		return this.client.get(`${this.basePath}/current`);
	}

	/**
	 * Get all plan benefits — public endpoint for pricing display
	 * @returns {Promise<Array>} Array of plan benefit configs
	 */
	async getPlans() {
		return this.client.get(`${this.basePath}/plans`);
	}

	/**
	 * Initiate Paystack payment for a subscription upgrade
	 * @param {string} plan - 'Starter' | 'Pro' | 'Business'
	 * @param {string} billingPeriod - 'Monthly' | 'Yearly'
	 * @param {string} callbackUrl - URL Paystack redirects to after payment
	 * @returns {Promise<{authorizationUrl: string, reference: string}>}
	 */
	async initiatePayment(plan, billingPeriod, callbackUrl) {
		return this.client.post(`${this.basePath}/initiate-payment`, { plan, billingPeriod, callbackUrl });
	}
}

export default new SubscriptionRepository(apiClient);
